import type { RecoProductCardFragment } from '@packages/gql/generated/shopping/graphql';
import type { ProductCardV2EnergyEfficiencyFlagsProps } from '@packages/modules/src/ProductCardV2/ProductCardV2.EnergyEfficiencyFlags.client';
import type { ProductCardV2EnergyEfficiencyFlagsLegacyProps } from '@packages/modules/src/ProductCardV2/ProductCardV2.EnergyEfficiencyFlagsLegacy';
import { getValidColorAndEfficiencyClass } from '@packages/shared/src/ui/EnergyEfficiencyFlag/colorsForEnergyEfficiency';

export const getEnergyEfficiencyFlags = (
  energyFlags: NonNullable<RecoProductCardFragment['product']>['powerEfficiencyFlags'],
) => {
  const flags: ProductCardV2EnergyEfficiencyFlagsProps['flags'] = [];

  if (energyFlags && energyFlags.length > 0) {
    energyFlags.forEach((flag) => {
      const colorAndEfficiencyClass = getValidColorAndEfficiencyClass(flag.color);

      if (colorAndEfficiencyClass === undefined) {
        return;
      }
      const { color, efficiencyClass } = colorAndEfficiencyClass;

      const overlay: ProductCardV2EnergyEfficiencyFlagsProps['flags'][0]['overlay'] = {
        title: flag.text,
        imgUrl: flag.link,
      };

      if (flag.hasOldLabel) {
        flags.push({
          variant: 'legacy',
          overlay,
          color,
          text: flag.level,
          size: 'medium',
        });
      } else {
        flags.push({
          variant: 'new',
          overlay,
          efficiencyClass,
          size: 'medium',
        });
      }
    });
  }

  return flags;
};

export const getLegacyEnergyEfficiencyFlags = (
  energyFlags: NonNullable<RecoProductCardFragment['product']>['powerEfficiencyFlags'],
): ProductCardV2EnergyEfficiencyFlagsLegacyProps['flags'] => {
  const flags = [] as Array<ProductCardV2EnergyEfficiencyFlagsLegacyProps['flags'][number]>;

  if (energyFlags && energyFlags.length > 0) {
    energyFlags.forEach((flag) => {
      const colorAndEfficiencyClass = getValidColorAndEfficiencyClass(flag.color);

      if (colorAndEfficiencyClass === undefined) {
        return;
      }
      const { color, efficiencyClass } = colorAndEfficiencyClass;

      const overlay: ProductCardV2EnergyEfficiencyFlagsLegacyProps['flags'][0]['overlay'] = {
        title: flag.text,
        imgUrl: flag.link,
      };

      if (flag.hasOldLabel) {
        flags.push({
          variant: 'legacy',
          overlay,
          color,
          text: flag.level,
          size: 'medium',
        });
      } else {
        flags.push({
          variant: 'new',
          overlay,
          efficiencyClass,
          size: 'medium',
        });
      }
    });
  }

  return flags;
};
